<template>
  <base-section id="theme-features">
    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'ACCOUNTING',
          icon: 'mdi-fountain-pen-tip',
          text: 'We prepare and maintain your books and records in accordance to statutory regulations, as well as prepare and file timely all required reports for your submissions.',
        },
        {
          title: 'CORPORATE TAX',
          icon: 'mdi-cellphone',
          text: 'We assist in the preparation of corporate tax for your submissions.',
        },
        {
          color: '#0BA137',
          dark: true,
          title: 'PERSONAL TAX',
          icon: 'mdi-pencil-box-outline',
          text: 'We assist in the preparation of personal tax for your submissions.',
        },
        {
          color: '#0BA137',
          dark: true,
          title: 'PAYROLL',
          icon: 'mdi-currency-usd',
          text: 'As your team grows, we will assist in your payroll processes so that you can grow your business and train your team.',
        },
        {
          title: 'FINANCIAL STATEMENTS',
          icon: 'mdi-finance',
          text: 'We assist in the preparation of financial statements for your submissions or for internal management.',
        },
        {
          title: '24/7 Support',
          icon: 'mdi-help-circle-outline',
          text: '',
        },
      ],
    }),
  }
</script>
